// #region IMPORT
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
/** Services Import */
import Global from '../../Services/Common/Global';
import Commons from '../../Services/Common/Common';
/** Components Import */
import { Loading } from '../../Components/MUIs';
import { useSelector } from 'react-redux';
import Profile from './Profile';
// #endregion

function ProfileFunction() {
  // #region 변수
  const { navigate } = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const [codeList, setCodeList] = useState([]);
  const [modalToggle4, setModalToggle4] = useState(); // 회원탈퇴 모달
  const [modalToggle5, setModalToggle5] = useState(); // 직인 모달
  const [modalToggle6, setModalToggle6] = useState(); // 직인 예시 모달
  const [idDelete, setIdDelete] = useState(false);
  const [careerPeriodList, setCareerPeriodList] = useState([]);
  const [nationList, setNationList] = useState([]); //국적 코드
  const [bloodList, setBloodList] = useState([]); //혈액형 코드
  const [inputs, setInputs] = useState({
    id: '',
    name: '',
    tel: '',
    emtel: '',
    birth: '',
    careerYn: '',
    careerPeriod: '',
    blood: '',
    address1: '',
    address2: '',
    post: '',
    nation: '',
    visa: '',
    photo: '',
    email: '',
    healthImage: '',
    sign: '',
    journeyman: '',
  });
  const [imageFile, setImageFile] = React.useState({
    //이미지 설정
    profileFiles: '', //파일 String(프로필)
    profileImage: '', // 파일 정보(프로필)
    profileFileName: '', //파일이름(프로필)
    healthFiles: '', //파일 String(보건카드)
    healthImage: '', // 파일 정보(보건카드)
    healthFileName: '', //파일이름(보건카드)
    signFiles: '', //파일 String(서명)
    signImage: '', // 파일 정보(서명)
    signFileName: '', //파일이름(서명)
    journeyFiles: '', //파일 String(직인)
    journeyImage: '', // 파일 정보(직인)
    journeyFileName: '', //파일이름(직인)
  });

  const [imageDialog, setImageDialog] = React.useState(false); // 프로필 팝업창
  const [signDialog, setSignDialog] = React.useState(false); // 서명 보기 팝업창
  const [signCreateDialog, setSignCreateDialog] = useState(); // 서명 등록 모달
  const [workSignature, setWorkSignature] = useState(''); // 전자서명 string
  // #endregion

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_Profile_R1',
            value1: userInfo.userid,
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type !== 'Error') {
            setInputs({
              ...inputs,
              id: data[0].ID,
              name: data[0].NAME,
              tel: data[0].TEL,
              emtel: data[0].EMTEL,
              birth: data[0].BIRTH,
              careerYn: data[0].CAREER_YN,
              careerPeriod: data[0].CAREER_PERIOD,
              blood: data[0].BLOOD,
              address1: data[0].ADDRESS1,
              address2: data[0].ADDRESS2,
              post: data[0].POST,
              nation: data[0].NATION,
              visa: data[0].VISA,
              photo: data[0].PHOTO,
              email: data[0].EMAIL,
              healthImage: data[0].HEALTH_IMAGE,
              sign: data[0].SIGN,
              journeyman: data[0].JOURNEYMAN,
            });
          }
        }
      });
      await SearchCode();
      await SearchLogic(state.PHOTO, 'profile');

      // setInputs({
      //   ...inputs,
      //   id: state.ID,
      //   name: state.NAME,
      //   tel: state.TEL,
      //   emtel: state.EMTEL,
      //   birth: state.BIRTH,
      //   careerYn: state.CAREER_YN,
      //   careerPeriod: state.CAREER_PERIOD,
      //   blood: state.BLOOD,
      //   address1: state.ADDRESS1,
      //   address2: state.ADDRESS2,
      //   post: state.POST,
      //   nation: state.NATION,
      //   visa: state.VISA,
      //   photo: state.PHOTO,
      //   email: state.EMAIL,
      //   healthImage: state.HEALTH_IMAGE,
      //   sign: state.SIGN,
      // });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // #region 조회
  // 경력 코드 조회
  const SearchCode = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GetCode',
          },
        ]
      ).then((result) => {
        let data = result.data;
        let data1 = [];
        let data2 = [];
        if (data.length === 0) {
          setCareerPeriodList([]);
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          throw new Error(data[0].message);
        } else {
          setCodeList(data);
          data = data.sort((a, b) => a.ref1 - b.ref1);
          data1 = data
            .filter((f) => f.groupCd === 'NATION')
            .map((item) => ({
              name: item.codeNm,
              value: item.code,
            }));
          data2 = data
            .filter((f) => f.groupCd === 'BloodType')
            .map((item) => ({
              name: item.codeNm,
              value: item.code,
            }));
          data = data
            .filter((f) => f.groupCd === 'CAREER_PERIOD')
            .map((item) => ({
              name: item.codeNm,
              value: item.code,
            }));
          // data.unshift({
          //   name: "없음",
          //   value: "None",
          // });
          setCareerPeriodList(data);
          setNationList(data1);
          setBloodList(data2);
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
    }
  };

  //사진 가져오기
  const SearchLogic = async (_item, _type) => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_item),
        }
      ).then((result) => {
        let data = result.data;

        if (data !== 'Error') {
          if (_type === 'profile') {
            setImageFile({
              ...imageFile,
              profileFiles: `data:image/png;base64,${data}`,
              profileImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          } else if (_type === 'health') {
            setImageFile({
              ...imageFile,
              healthFiles: `data:image/png;base64,${data}`,
              healthImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          } else if (_type === 'sign') {
            setImageFile({
              ...imageFile,
              signFiles: `data:image/png;base64,${data}`,
              signImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          } else if (_type === 'journeyman') {
            setImageFile({
              ...imageFile,
              journeyFiles: `data:image/png;base64,${data}`,
              journeyImage: {
                name: _item.split('/')[_item.split('/').length - 1],
              },
            });
          }
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
    }
  };
  // #endregion

  // #region 저장
  // 개인정보 수정
  const SaveLogic1 = async () => {
    setLoading(true);
    let userData = null;
    let formList = new FormData();
    let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    try {
      if (!inputs.name) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.lanType !== 'MENU' && f.lanId === 'EnterName'
                ).lanNm, // 이름을 입력하세요.
          type: 'warning',
        });
      } else if (!inputs.tel) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) =>
                    f.lanType !== 'MENU' &&
                    f.lanId === 'PleaseEnterYourPhoneNumber'
                ).lanNm, // 전화번호를 입력하세요.
          type: 'warning',
        });
      } else if (!inputs.email) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.lanType !== 'MENU' && f.lanId === 'EnterEmail'
                ).lanNm, //  이메일을 입력하세요.
          type: 'warning',
        });
      } else if (inputs.careerYn === 'Y' && !inputs.careerPeriod) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.lanType !== 'MENU' && f.lanId === 'EnterCareer'
                ).lanNm, //   경력기간을 입력하세요.
          type: 'warning',
        });
      } else if (!emailRegex.test(inputs.email)) {
        setSnackbar({
          ...snackbar,
          open: true,
          message: 'E-Mail을 확인 하세요.',
          type: 'warning',
        });
        return false;
      } else {
        if (imageFile.profileImage.size) {
          // 프로필 사진이 변경된 경우
          formList.append('value1', userInfo.userid);
          formList.append(
            'value2',
            Commons.EncryptAES(`User_Info/${inputs.id}/Profile`)
          );
          formList.append('value3', imageFile.profileImage);

          await Commons.Axios(
            'file',
            Global.base.useUrl + Global.urls.Execute.ftpRequest,
            null,
            formList
          ).then((result) => {
            let data = result.data;
          });
        }

        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          [
            {
              procedureName: 'SP_MyPage_U2',
              value1: Commons.EncryptAES(inputs.id) || '',
              value2: Commons.EncryptAES(inputs.name) || '',
              value3: Commons.EncryptAES(inputs.tel) || '',
              value4: Commons.EncryptAES(inputs.emtel) || '',
              value5: Commons.EncryptAES(inputs.careerYn) || '',
              value6: Commons.EncryptAES(inputs.careerPeriod) || '',
              value7: Commons.EncryptAES(inputs.address1) || '',
              value8: Commons.EncryptAES(inputs.address2) || '',
              value9: Commons.EncryptAES(inputs.post) || '',
              value10: Commons.EncryptAES(inputs.visa) || '',
              value11:
                Commons.EncryptAES(
                  imageFile.profileImage
                    ? `User_Info/${inputs.id}/Profile/${imageFile.profileImage.name}`
                    : ''
                ) || '',
              value12: Commons.EncryptAES(inputs.email) || '',
              value13: Commons.EncryptAES(inputs.blood) || '',
              value14: Commons.EncryptAES(inputs.nation) || '',
            },
          ]
        ).then((result) => {
          let data = result.data;

          if (data.length > 0) {
            if (data[0].type === 'Ok') {
              // userInfo photo 업데이트
              // IndexedDb.UpdateTable("UserInfo", Commons.EncryptAES(state.ID), {
              //   ...userData,
              //   photo: imageFile.profileImage
              //     ? `User_Info/${inputs.id}/Profile/${imageFile.profileImage.name}`
              //     : "",
              //   userid: Commons.EncryptAES(state.ID),
              // });

              setSnackbar({
                ...snackbar,
                open: true,
                message:
                  lanInfo.length > 0
                    ? lanInfo.filter((f) => f.lanId === 'ItHasBeenSaved')[0]
                        .lanNm
                    : '',
                type: 'success',
              });
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
              });
            } else {
              throw new Error(data[0].message ? data[0].message : '');
            }
          }
        });
      }
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // 보건카드 저장
  const SaveLogic2 = async () => {
    setLoading(true);
    let formList = new FormData();

    try {
      if (!imageFile.healthImage) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.lanType !== 'MENU' && f.lanId === 'NoImages'
                ).lanNm, // 사진이 없습니다.
          type: 'warning',
        });
        return false;
      } else {
        if (imageFile.healthImage.size) {
          formList.append('value1', userInfo.userid);
          formList.append(
            'value2',
            Commons.EncryptAES(`User_Info/${inputs.id}/Health`)
          );
          formList.append('value3', imageFile.healthImage);

          await Commons.Axios(
            'file',
            Global.base.useUrl + Global.urls.Execute.ftpRequest,
            null,
            formList
          ).then((result) => {
            let data = result.data;
          });
        }

        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          [
            {
              procedureName: 'SP_MyPage_U3',
              value1: Commons.EncryptAES(inputs.id) || '',
              value2:
                Commons.EncryptAES(
                  `User_Info/${inputs.id}/Health/${imageFile.healthImage.name}`
                ) || '',
            },
          ]
        ).then((result) => {
          let data = result.data;

          if (data.length > 0) {
            if (data[0].type === 'Ok') {
              setInputs({
                ...inputs,
                healthImage: `User_Info/${inputs.id}/Health/${imageFile.healthImage.name}`,
              });

              setSnackbar({
                ...snackbar,
                open: true,
                message:
                  lanInfo.length > 0
                    ? lanInfo.filter((f) => f.lanId === 'ItHasBeenSaved')[0]
                        .lanNm
                    : '',
                type: 'success',
              });
            } else {
              throw new Error(data[0].message ? data[0].message : '');
            }
          }
        });
      }
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // 서명 저장
  const SaveLogic3 = async (_item) => {
    setLoading(true);
    let formList = new FormData();

    try {
      if (_item.size) {
        formList.append('value1', userInfo.userid);
        formList.append(
          'value2',
          Commons.EncryptAES(`User_Info/${inputs.id}/Sign`)
        );
        formList.append('value3', _item);

        await Commons.Axios(
          'file',
          Global.base.useUrl + Global.urls.Execute.ftpRequest,
          null,
          formList
        ).then((result) => {
          let data = result.data;
        });
      }

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_U4',
            value1: Commons.EncryptAES(inputs.id) || '',
            value2:
              Commons.EncryptAES(`User_Info/${inputs.id}/Sign/${_item.name}`) ||
              '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Ok') {
            setInputs({
              ...inputs,
              sign: `User_Info/${inputs.id}/Sign/${_item.name}`,
            });

            SearchLogic(`User_Info/${inputs.id}/Sign/${_item.name}`, 'sign');

            setSnackbar({
              ...snackbar,
              open: true,
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.lanId === 'ItHasBeenSaved')[0].lanNm
                  : '',
              type: 'success',
            });
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // 직인 저장
  const SaveLogic4 = async () => {
    setLoading(true);
    let formList = new FormData();

    try {
      if (!imageFile.journeyImage) {
        setSnackbar({
          ...snackbar,
          open: true,
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) => f.lanType !== 'MENU' && f.lanId === 'NoImages'
                ).lanNm,
          type: 'warning', // 사진이 없습니다.
        });
        return false;
      }

      if (imageFile.journeyImage.size) {
        formList.append('value1', userInfo.userid);
        formList.append(
          'value2',
          Commons.EncryptAES(`User_Info/${inputs.id}/Journeyman`)
        );
        formList.append('value3', imageFile.journeyImage);

        await Commons.Axios(
          'file',
          Global.base.useUrl + Global.urls.Execute.ftpRequest,
          null,
          formList
        ).then((result) => {
          let data = result.data;
        });
      }

      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_U5',
            _userid: Commons.EncryptAES(inputs.id) || '',
            _journeyman:
              Commons.EncryptAES(
                `User_Info/${inputs.id}/Journeyman/${imageFile.journeyImage.name}`
              ) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length > 0) {
          if (data[0].type === 'Ok') {
            setInputs({
              ...inputs,
              journeyman: `User_Info/${inputs.id}/Journeyman/${imageFile.journeyImage.name}`,
            });

            setSnackbar({
              ...snackbar,
              open: true,
              message:
                lanInfo.length > 0
                  ? lanInfo.filter((f) => f.lanId === 'ItHasBeenSaved')[0].lanNm
                  : '',
              type: 'success',
            });
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  // #endregion

  // #region 삭제
  // 회원 탈퇴
  const DeleteLogic1 = async (_item) => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_D1',
            value1: userInfo.userid || '',
          },
        ]
      ).then(async (result) => {
        let data = result.data;
        if (data.length > 0) {
          if (data[0].TYPE === 'Ok') {
            window.localStorage.setItem(
              'auth',
              JSON.stringify({
                auth: false,
              })
            );

            navigate('/');
          } else {
            throw new Error(data[0].message ? data[0].message : '');
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // 프로필 이미지 삭제
  const DeleteLogic2 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MyPage_D2',
            value1: userInfo.userid,
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data[0].TYPE === 'Ok') {
          setImageFile({
            ...imageFile,
            profileFiles: '', //파일 String
            profileImage: '', // 파일 정보
            profileFileName: '', //파일이름
          });
        }
      });
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  // #endregion

  // #region 나머지 함수
  window.onbeforeunload = function () {
    window.location.href = '/';
  };
  // #endregion

  return (
    <div className="wrap">
      <Profile
        userInfo={userInfo}
        lanInfo={lanInfo}
        codeList={codeList}
        careerPeriodList={careerPeriodList}
        setCareerPeriodList={setCareerPeriodList}
        inputs={inputs}
        setInputs={setInputs}
        imageFile={imageFile}
        setImageFile={setImageFile}
        imageDialog={imageDialog}
        setImageDialog={setImageDialog}
        signDialog={signDialog}
        setSignDialog={setSignDialog}
        signCreateDialog={signCreateDialog}
        setSignCreateDialog={setSignCreateDialog}
        workSignature={workSignature}
        setWorkSignature={setWorkSignature}
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        idDelete={idDelete}
        setIdDelete={setIdDelete}
        modalToggle4={modalToggle4}
        setModalToggle4={setModalToggle4}
        modalToggle5={modalToggle5}
        setModalToggle5={setModalToggle5}
        modalToggle6={modalToggle6}
        setModalToggle6={setModalToggle6}
        bloodList={bloodList}
        setBloodList={setBloodList}
        nationList={nationList}
        setNationList={setNationList}
        // 함수
        SearchLogic={SearchLogic}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        SaveLogic3={SaveLogic3}
        SaveLogic4={SaveLogic4}
        DeleteLogic1={DeleteLogic1}
        DeleteLogic2={DeleteLogic2}
      />
      <Loading open={loading} />
    </div>
  );
}

export default ProfileFunction;
